import app from 'flarum/forum/app';
import registerWidget from '../common/registerWidget';
app.initializers.add('ubhu-ubuntu-release-countdown-widget', () => {
  registerWidget(app);
});